<template>
  <div class="lee-scroll" :style="'height:'+maxHeight+'px'">
    <div v-if="showBar" class="scrollTrack" :style="'width:'+width+'px;backgroundColor:'+trackColor">
      <div @click="barTop-=width;oldP=barTop"  v-if="arrow" class="arrows t" :class="{disabled:maxTop}"  :style="'width:'+width+'px;height:'+width+'px'"></div>
      <div class="bar" @mousedown.prevent="mousedown" @mousemove.prevent="mousemove" @mouseup="mouseup"
           @touchstart.prevent="touchstart" @touchmove.prevent="touchmove" @touchend="touchend"
           :style="'transform:translateY('+barTop+'px);backgroundColor:'+barColor"></div>
      <div @click="barTop+=width;oldP=barTop" v-if="arrow" class="arrows b" :class="{disabled:maxBottom}"  :style="'width:'+width+'px;height:'+width+'px'"></div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
    name: 'LeeScroll',
    inheritAttrs: false,
    data() {
        return {
            maxTop:false,//滚动条是否到达最顶
            maxBottom:false,//滚动条是否到达最底
            arrow: false,//是否显示滚动条的箭头
            showBar: false,//是否显示滚动条
            barTop: 0,//滚动条位置
            oldP: 0,//保存上一次滚动条位置
            barDown: false,//bar是否按下去
            oldY: 0//bar鼠标DOWN的时候位置
        }
    },
    mounted() {
        if (this.layout.indexOf('arrow') > -1) {
            this.arrow = true
        } else {
            this.arrow = false
        }
        document.addEventListener('mousemove', (e) => {
            if (this.barDown) {
                let newY = e.pageY
                this.barTop = this.oldP + newY - this.oldY
            }
        })
        document.addEventListener('mouseup', () => {
            this.barDown = false
        })
        //为了让窗口变化时，滚动条也要适应
        window.addEventListener('resize', () => {
            this.barTop -= 1
        })

    },
    methods: {
        mousedown(e) {
            this.barDown = true
            this.oldY = e.pageY
        },
        mousemove(e) {
            if (this.barDown) {
                let newY = e.pageY
                this.barTop = this.oldP + newY - this.oldY
            }
        },
        mouseup() {
            this.barDown = false
        },
        touchstart(e) {
            this.barDown = true
            this.oldY = e.targetTouches[0].pageY
        },
        touchmove(e) {
            if (this.barDown) {
                let newY = e.targetTouches[0].pageY
                this.barTop = this.oldP + newY - this.oldY
            }
        },
        touchend() {
            this.barDown = false
        }
    },
    computed: {},
    props: {
        maxHeight: {
            type: Number,
            default: 300
        },
        width: {
            type: Number,
            default: 12
        },
        trackColor: {
            type: String,
            default: '#eee'
        },
        barColor: {
            type: String,
            default: '#46bd87'
        },
        layout: {
            type: String,
            default: 'bar'
        }
    },
    watch: {
        barDown: {
            immediate: true,
            handler(value) {
                if(!value){
                    this.oldP=this.barTop
                }
            }
        },
        barTop: {
            immediate: true,
            handler(value) {
                this.$nextTick(() => {
                    let target = this.$slots.default[0].elm
                    let arrowH = this.layout.indexOf('arrow') > -1 ? this.width : 0;
                    let allHeight = target.scrollHeight
                    let maxY = allHeight - this.maxHeight//内容最大的移动的值
                    let maxbarY = this.maxHeight - 50 - 2 * arrowH//滚动条最大的移动的值
                    //滚动条
                    if (value <= 0) {
                        this.barTop = 0
                        this.maxTop=true
                    }else{
                        this.maxTop=false
                    }
                    if (value >= maxbarY) {
                        this.barTop = maxbarY
                        this.maxBottom=true
                    }else{
                        this.maxBottom=false
                    }
                    //内容
                    if (maxY > 0) {
                        this.showBar = true
                        let translateY = -(maxY / maxbarY) * this.barTop
                        if (translateY >= 0) {
                            translateY = 0
                        }
                        if (translateY <= -maxY) {
                            translateY = -maxY
                        }
                        target.style.cssText = 'padding-right:' + 3 * this.width + 'px;transform:translateY(' + translateY + 'px)'

                    }
                })
            }
        }
    }
};
</script>
<style>
.lee-scroll {
  width: fit-content;
  position: relative;
  overflow: hidden;
}

.lee-scroll .scrollTrack {
  height: 100%;
  position: absolute;
  background: #999;
  top: 0;
  right: 0;
  z-index: 1;
}

.lee-scroll .scrollTrack .arrows {
  padding-bottom: 100%;
  display: flex;
  justify-content: center;
}
.lee-scroll .scrollTrack .arrows:before{
  content: '';
  border-width: 3px;
  border-style: solid;
}
.lee-scroll .scrollTrack .arrows.t:before{
  border-color: transparent transparent #333 transparent;
  margin-bottom:33.33% ;

}
.lee-scroll .scrollTrack .arrows.b:before{
  border-color: #333 transparent transparent transparent;
  margin-top:33.33% ;
}



.lee-scroll .scrollTrack .arrows.b {
  bottom: 0;
  position: absolute;
}
.lee-scroll .scrollTrack .arrows.disabled{
  pointer-events: none;
  opacity: .4;
}

.lee-scroll .bar {
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeScroll.vue